module.exports = __webpack_public_path__ + "img/bingo_ball-23.37dc4263.png";